const API_ENDPOINT = 'https://api.coinbase.com/v2/prices/';
const METALS = ['XAU-USD', 'XAG-USD', 'XPT-USD']; // Adding platinum (XPT-USD)

const getMetalPrice = async (metal) => {
  const response = await fetch(`${API_ENDPOINT}${metal}/buy`, {
    method: 'GET'
  });

  if (!response.ok) {
    throw new Error(`Error fetching ${metal} price: ${response.status}`);
  }

  const data = await response.json();
  const price = data && data.data && data.data.amount ? parseFloat(data.data.amount).toFixed(2) : 'N/A';
  console.log(`${metal} price:`, price);

  // Store price in localStorage
  localStorage.setItem(`${metal}_price`, price);
  localStorage.setItem(`${metal}_timestamp`, Date.now());

  return price;
};

const displayPrices = async () => {
  const goldPriceSpan = document.getElementById('goldPrice');
  const silverPriceSpan = document.getElementById('silverPrice');
  const platinumPriceSpan = document.getElementById('platinumPrice');

  try {
    let goldPrice = localStorage.getItem('XAU-USD_price');
    let silverPrice = localStorage.getItem('XAG-USD_price');
    let platinumPrice = localStorage.getItem('XPT-USD_price');

    const currentTime = Date.now();
    const lastUpdate = parseInt(localStorage.getItem('last_update'), 10) || 0;
    const twentyFourHours = 24 * 60 * 60 * 1000;

    if (currentTime - lastUpdate >= twentyFourHours) {
      goldPrice = await getMetalPrice('XAU-USD');
      silverPrice = await getMetalPrice('XAG-USD');
      platinumPrice = await getMetalPrice('XPT-USD');
      localStorage.setItem('last_update', currentTime);
    }

    goldPriceSpan.textContent = `Gold $${goldPrice}/oz`;
    silverPriceSpan.textContent = `Silver $${silverPrice}/oz`;
    platinumPriceSpan.textContent = `Platinum $${platinumPrice}/oz`;
  } catch (error) {
    console.error(error);
  }
};

// Initial display of prices
displayPrices();
 